import {
  BaseTransaction,
  TransferTransaction,
  CheckTransaction,
  ACHTransaction,
  WireTransaction,
} from "../types/transactionType";

export const isEmail = (email: string) => {
  let regex: RegExp = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

  return regex.test(email);
};

export const isValidPassword = (password: string) => {
  let regex: RegExp = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,16}$/;

  return regex.test(password);
};

export const validateCreateTransactionBody = (
  transactionPayload:
    | BaseTransaction
    | TransferTransaction
    | CheckTransaction
    | ACHTransaction
    | WireTransaction
    | null
): boolean => {
  const notRequiredFields: Array<string> = [
    "description",
    "address",
    "apartment",
    "state",
    "city",
    "country",
    "zip",
    "memo",
    "bankTransactionType",
  ];

  let isValid = true;

  if (transactionPayload !== null && typeof transactionPayload === "object") {
    Object.entries(transactionPayload).forEach(([key, value]) => {
      if (!notRequiredFields.includes(key)) {
        if (value === null || value === undefined || value === "") {
          isValid = false;
        } else if (key === 'account' || key === 'fromAccount' || key === 'amount') {
          if (isNaN(value) || value === 0) {
            isValid = false;
          }
        }
      }
    });
  } else {
    isValid = false;
  }
  return isValid;
};
